import {validate as validator} from "validate.js";

const rules = () => {
    return {
        code: {
            presence: true,
            length: {
                minimum: 1,
            }
        },
        category_id: {
            presence: true,
        },
    }
};

const validationRules = {};
validationRules['flower'] = {
    group_id: {
        presence: true,
    },
}

validationRules['variety'] = {};

const validate = (moduleItem, isFlower) => {
    const type = isFlower ? 'flower' : 'variety';
    return validator(moduleItem, Object.assign(validationRules[type], rules()))
};

export default {validate};
